import script from "./TwoDCompareAnnotator.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoDCompareAnnotator.vue?vue&type=script&setup=true&lang=js"

import "./TwoDCompareAnnotator.vue?vue&type=style&index=0&id=00965f7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00965f7a"]])

export default __exports__